import { Component, OnInit } from '@angular/core';

import { Client } from '../../shared/client.model';

import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  ToastController
} from '@ionic/angular';
import { Product } from '../../shared/product.model';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { OrderResponse } from '../../shared/orderResponse.model';
import { OrderDetailResponse } from '../../shared/orderDetailResponse.model';
import { Order } from '../../shared/order.model';
import { BnplService } from 'src/app/service/bnpl.service';
import { Fua } from 'src/app/shared/fua.model';
import { DetailBnpl } from 'src/app/shared/detailBnpl.model';
import { Constant } from '../../shared/model/Constant';


@Component({
  selector: 'app-detail',
  templateUrl: './detail.page.html',
  styleUrls: ['./detail.page.scss'],
})
export class DetailPage implements OnInit {

  detailBnpl: DetailBnpl;
  balance: number = 0;
  userComissions: number = 0;
  detailPayments: any[];
  accounts: any[];
  accountSelect: any;

  orders: Order[];
  client: Client;
  product: Product;
  order: OrderResponse;
  orderDetails: OrderDetailResponse[];
  orderId: string;
  totalAmountProduct: number;
  descount: string;
  showConfirm: boolean;
  showAccounts: boolean;
  showModalBnplInfo: boolean = false;
  title: string = "!UPS¡";
  message: string;
  bnplTransactionId: string;
  ipClient: string = "127.0.0.1";


  constructor(public modalController: ModalController,
    public alertController: AlertController,
    public toastController: ToastController,
    private nav: NavController,
    private authService: AuthService,
    private bnplService: BnplService,
    public loadingController: LoadingController, private router: Router) {

  }

  openModalAccounts() {
    this.showAccounts = true;
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'primary'
    });
    toast.present();
  }

  ngOnInit() {
    this.detailBnpl = JSON.parse(localStorage.getItem(Constant.detailBnpl));
    this.accounts = this.detailBnpl.accounts;
    this.accountSelect = this.accounts[0];
    this.bnplService.getIp().subscribe((res: any) => {
      this.ipClient = res.IPv4;
      this.purchaseOrder();
    }, error => {
      console.warn('Error fua no ip 1', error);
      this.bnplService.getIp1().subscribe((res: any) => {
        console.log(res);
        this.ipClient = res.ip;
        this.purchaseOrder();
      }, error => {
        console.warn('Error fua no ip 2', error);
      });
    });

  }

  purchaseOrder() {
    console.log("purchaseOrder");
    localStorage.removeItem(Constant.detailBnpl);
    var requestPurchaseOrder = {
      "bnplTransactionId": this.detailBnpl.bnplTransactionId,
      "idOrden": this.detailBnpl.order.idOrder,
      "ip": this.ipClient,
      "idClient": this.detailBnpl.order.idUser,
      "totalPrice": this.detailBnpl.order.totalAmount,
    };

    this.bnplService.sendTrxPurchaseOrderBnpl(requestPurchaseOrder).subscribe((res: any) => {
      // this.userComissions = res.userCommission;
      this.detailPayments = res.installments;
    }, error => {
      this.showModalBnplInfo = true;
      this.message = "No se pudo crear la intencion de compra.";
    });
  }

  sendTyC() {
    var requestSelectAccount = {
      "idOrder": this.detailBnpl.order.idOrder,
      "ip": this.ipClient,
      "idClient": this.detailBnpl.order.idUser,
      "bnplTransactionId": this.detailBnpl.bnplTransactionId,
      "idAccount": this.accountSelect.id,
      "typeAccount": this.accountSelect.type,
      "numberAccount": this.detailBnpl.accounts[0].number.substring(this.detailBnpl.accounts[0].number.length - 4, this.detailBnpl.accounts[0].number.length)
    };
    this.bnplService.sendTrxSelectAccountBnpl(requestSelectAccount).subscribe((res: any) => {
      this.accountSelect = res;
      localStorage.setItem(Constant.detailBnpl, JSON.stringify(this.detailBnpl));
      this.router.navigate(['/termsBnpl']);
    }, error => {
      this.showModalBnplInfo = true;
      this.message = "No se pudo seleccionar la cuenta default.";
    });

  }

  close() {
    this.showConfirm = false;
    this.showAccounts = false;
  }


  onWillDismissConfirm(modalEvent: Event) {
    if (modalEvent.type === 'willDismiss') {
      this.showConfirm = false;
    }
  }

  onWillDismissMethod(modalEvent: Event) {
    if (modalEvent.type === 'willDismiss') {
      this.showAccounts = false;
    }
  }

  selectAccount(account: any) {
    this.accountSelect = account;
    this.showAccounts = false;
  }


}
